<div class="otp-verify-container">
  <p class="primary-font-medium otp-verify-title form-label">{{ 'otp_input.title' | translate }}</p>

  <div class="otp-verify-input-container flex-center" dir="ltr">
    @for (value of otpArray; track $index) {
      <input
        [type]="setting.numbersOnly ? 'tel' : 'text'"
        class="otp-input primary-font-regular flex-center"
        [class]="setting.inputClass"
        [class.error-input]="hasError"
        [class.focused]="$index === focusedIndex()"
        [class.filled]="value"
        maxlength="1"
        inputmode="numeric"
        autocomplete="off"
        [value]="value"
        [placeholder]="''"
        [id]="'otp-' + $index"
        [attr.aria-label]="'OTP digit ' + ($index + 1)"
        (input)="onInputChange($event, $index)"
        (keydown)="onKeyDown($event, $index)"
        (focus)="onFocus($index)"
        appNumberOnly
        (paste)="onPaste($event)"
      />
    }
  </div>

  <div class="otp-verify-footer">
    <p
      class="primary-font-medium otp-verify-footer-text"
      [class.otp-verify-text-theme-two]="theme() === GbTheme.ThemeTwo"
    >
      @if (setting.btnLabel) {
        {{ setting.btnLabel | translate }}
      } @else {
        {{ 'otp_input.btn_label' | translate }}
      }
      @if (theme() === GbTheme.ThemeTwo) {
        <br />
      }
      <button
        type="button"
        class="resend-button default-button"
        [class.resend-button-theme-two]="theme() === GbTheme.ThemeTwo"
        (click)="resendOtp()"
        (keyup.enter)="resendOtp()"
        (keyup.space)="resendOtp()"
      >
        {{ setting.btnText | translate }}
        @if (counter() && counter() !== 0) {
          <span class="d-none">
            @if (!setting.timerType) {
              {{ 'otp_input.timer_label' | translate }} {{ counter() }}
              {{ 'otp_input.seconds' | translate }}
            } @else {
              {{ 'otp_input.timer_label' | translate }} {{ formatSecsToMins(counter()) }}
              {{ 'otp_input.minutes' | translate }}
            }
          </span>
        }
      </button>
    </p>
  </div>
</div>
